import { render, staticRenderFns } from "./FeedSideButton.vue?vue&type=template&id=d651d280&scoped=true&"
import script from "./FeedSideButton.vue?vue&type=script&lang=ts&"
export * from "./FeedSideButton.vue?vue&type=script&lang=ts&"
import style0 from "./FeedSideButton.vue?vue&type=style&index=0&id=d651d280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d651d280",
  null
  
)

export default component.exports